import axios from "../axios";

export default class TypeAttendanceService{
    async GetTypeAttendances(){
        let res = await axios.get("TypeAttendance");
        return res.data;
    }
}